module.exports = __webpack_public_path__ + "static/media/logoEduMaterial.0042e9e3.png";